import { BaseSubChain } from 'domain/entities/monomer-chains/BaseSubChain';

export class PhosphateSubChain extends BaseSubChain {}
